import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { ModeSignedUrlQuery } from '../../../core/schema/query-definitions/system.graphql';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-graph-embed',
  templateUrl: './graph-embed.component.html',
  styleUrls: ['./graph-embed.component.sass'],
})
export class GraphEmbedComponent implements OnInit, OnChanges, OnDestroy {
  @Input() embedUrl?: string;

  @Input() height: string = '395';

  private accessKey = '77b0d947c8ccb445ad93b44f';

  private run = 'now';

  private url?: string;

  private timeout: any;

  public signedUrl?: string;

  public isLoadingData: boolean = false;

  public isLoadingSpinner: boolean = true;

  private destroyed$: Subject<void> = new Subject<void>();

  constructor(private readonly signedUrlQuery: ModeSignedUrlQuery) {}

  ngOnInit(): void {
    this.signEmbedUrl();
  }

  ngOnDestroy(): void {
    this.clearEmbedTimeout();
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    const embedUrl = changes.embedUrl;
    if (embedUrl && !embedUrl.firstChange && embedUrl.previousValue !== embedUrl.currentValue) {
      this.clearEmbedTimeout();
      this.signEmbedUrl();
    }
  }

  signEmbedUrl() {
    if (this.embedUrl) {
      const url = new URL(this.embedUrl);
      url.searchParams.delete('param_session_dynamic_date_range_key');

      url.searchParams.append('access_key', this.accessKey);
      url.searchParams.append('run', this.run);
      this.url = url.href;

      this.isLoadingData = true;
      this.isLoadingSpinner = true;
      if (this.url) {
        this.signedUrlQuery
          .fetch(
            {
              input: {
                url: this.url,
                key: this.accessKey,
              },
            },
            {
              fetchPolicy: 'network-only',
            },
          )
          .pipe(
            map((response) => response.data.modeSignedUrl.modeSignedUrl),
            takeUntil(this.destroyed$),
          )
          .subscribe({
            next: (response: any) => {
              this.signedUrl = response.signedUrl;
              this.isLoadingData = false;
              this.timeout = setTimeout(() => this.signEmbedUrl(), 1000 * 60 * 10); // Reload after 10 minutes

              // Remove the spinner after a 8 second timeout to avoid iframe whitespace
              setTimeout(() => (this.isLoadingSpinner = false), 8000);
            },
          });
      }
    }
  }

  private clearEmbedTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }
}
